export default "__VITE_ASSET__0HiBC2zN__"